export const EXCERPT_MAX = 200;

export const formatPublishedAt = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const limitExcerpt = (text) => {
  if (!text || text.length <= EXCERPT_MAX) return text;
  return `${text.slice(0, EXCERPT_MAX - 1).trimEnd()}…`;
};

export const byPublishedAtDesc = (posts) =>
  [...posts].sort((a, b) => {
    const aTime = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
    const bTime = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
    return bTime - aTime;
  });

export const isReleased = (post) => {
  if (!post.publishedAt) return false;
  const time = new Date(post.publishedAt).getTime();
  return !Number.isNaN(time) && time <= Date.now();
};
